import { web3Client,apiClient } from '../../api/clients'
const environment = process.env.REACT_APP_WALLET_TYPE;
//dashboard
const getDetais = (url,customerId) =>{
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}/${customerId}`);
    }else{
        return apiClient.get(`${url}/${customerId}`);
    }
}
const get = (url) =>{
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}`);
    }else{
        return apiClient.get(`${url}`);
    }
}
const getNetworks = (url,coin,customerId) =>{
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}/${coin}/${customerId}`);
    }else{
        return apiClient.get(`${url}/${coin}/${customerId}`);
    }
}
const getCurrencyData = (url, coin, network, merchant,id) => {
    if(environment === 'non_custodial'){
        return web3Client.get(`${url}/${coin}/${network}/${merchant}/${id}`);
    }else{
        return apiClient.get(`${url}/${coin}/${network}/${merchant}/${id}`);
    }
}
const save = (url,obj) =>{
    if(environment === 'non_custodial'){
        return web3Client.post(`${url}`,obj);
    }else{
        return apiClient.post(`${url}`,obj);
    }
}
const update = (url,obj) =>{
    if(environment === 'non_custodial'){
        return web3Client.put(`${url}`,obj);
    }else{
        return apiClient.put(`${url}`,obj);
    }
}
export {getDetais,get,getNetworks,save,update,getCurrencyData}